import {
  IChildrenProp,
  IColorProp,
  IOnlyIcon,
  ISize,
} from 'types/components/components.interface';
import './Label.scss';
import { Attributes, HTMLAttributes } from 'react';

interface ILabelProps
  extends IChildrenProp,
    IColorProp,
    ISize,
    Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
  withText?: boolean;
}

const Label = ({
  children,
  color = 'black',
  size = 'default',
  withText,
  ...props
}: ILabelProps) => {
  return (
    <div
      {...props}
      className={`magellan-label${withText ? ' with-text' : ''} ${color} ${
        props.className
      } ${size}`}>
      {children}
    </div>
  );
};

export default Label;
